import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { AnalyticsStructurePieResult, AnalyticsStructureSingleValue } from 'src/app/models/ianalytics.interface';
import { ChartOptionsBar } from 'src/app/models/igraph.model';

@Component({
  selector: 'app-structure-graph-bar',
  templateUrl: './structure-graph-bar.component.html',
  styleUrls: ['./structure-graph-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StructureGraphBarComponent implements OnInit, OnChanges {
  @Input() data: AnalyticsStructurePieResult;
  @Input() isOptimized: boolean = true;
  @Input() percentOptimized: number = 5;

  graphOptions: Partial<ChartOptionsBar>;

  constructor() {}

  ngOnInit(): void {
    this.updateGraphOptions();
  }

  ngOnChanges(): void {
    this.updateGraphOptions();
  }

  private updateGraphOptions(): void {
    if (!this.data || !Array.isArray(this.data.data)) {
      console.error('Invalid or missing data for bar graph:', this.data);
      this.graphOptions = undefined;
      return;
    }

    const stat = this.isOptimized
      ? this.prepareOptimizedData(this.data.data, this.percentOptimized)
      : this.data.data;

    if (stat.length === 0) {
      console.error('No valid statistics data after optimization:', stat);
      this.graphOptions = undefined;
      return;
    }

    this.graphOptions = {
      series: [{
        name: this.data.caption || 'Без названия',
        data: stat.map(o => Number(o.percent.toFixed(2)))
      }],
      chart: {
        height: 480,
        type: 'bar',
        toolbar: { show: true }
      },
      title: {
        text: this.data.caption || 'График'
      },
      plotOptions: {
        bar: {
          columnWidth: '50%',
          dataLabels: { position: 'top' }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: (val: number) => `${val} %`,
        offsetY: -20,
        style: { fontSize: '12px', colors: ['#304758'] }
      },
      xaxis: {
        labels: { show: false },
        categories: stat.map(o => `${o.key} (${o.value})`),
        position: 'bottom',
        axisBorder: { show: true },
        // labels: { rotate: 0 },
        axisTicks: { show: true }
      },
      stroke: { width: 2 },
      grid: { row: { colors: ['#fff', '#f2f2f2'] } },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'horizontal',
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.85,
          opacityTo: 0.85,
          stops: [50, 0, 100]
        }
      },
      yaxis: [{
        min: 0,
        max: 100,
        labels: { formatter: (val: number) => `${val}%` }
      }],
      tooltip: {}
    };
  }

  private prepareOptimizedData(data: AnalyticsStructureSingleValue[], optimize: number): AnalyticsStructureSingleValue[] {
    const more = data.filter(o => o.percent >= optimize);
    const less = data
      .filter(o => o.percent < optimize)
      .reduce((a, b) => ({
        key: 'Другое',
        value: a.value + b.value,
        percent: a.percent + b.percent
      } as AnalyticsStructureSingleValue), { key: '', value: 0, percent: 0 } as AnalyticsStructureSingleValue);

    return less.value > 0 ? [...more, less] : more;
  }
}
